/**
 * Scrollbar styles for Turn Connect applications.
 * Provides consistent scrollbar styling across components.
 */
import { colors } from './colors';

export interface ScrollbarStyles {
  photoSlider: string;
  verticalList: string;
  searchResults: string;
  activitiesList: string;
  // Add more scrollbar variations here as needed
}

export const scrollbars: ScrollbarStyles = {
  /**
   * Horizontal photo slider scrollbar styles
   * Used in ServicePhotosView and similar components
   */
  photoSlider: `
    .photo-slider::-webkit-scrollbar {
      height: 6px;
    }
    .photo-slider::-webkit-scrollbar-track {
      background: ${colors.background.tertiary};
      border-radius: 3px;
    }
    .photo-slider::-webkit-scrollbar-thumb {
      background: ${colors.background.quaternary}
      border-radius: 3px;
    }
    .photo-slider::-webkit-scrollbar-thumb:hover {
      background: ${colors.background.elevated}
    }
  `,

  /**
   * Vertical list scrollbar styles
   * Used for vertical scrolling lists and content areas
   */
  verticalList: `
    .vertical-list::-webkit-scrollbar {
      width: 6px;
    }
    .vertical-list::-webkit-scrollbar-track {
      background: ${colors.background.tertiary};
      border-radius: 3px;
    }
    .vertical-list::-webkit-scrollbar-thumb {
      background: ${colors.background.quaternary};
      border-radius: 3px;
    }
    .vertical-list::-webkit-scrollbar-thumb:hover {
      background: ${colors.background.elevated}
    }
  `,

  /**
   * Search results scrollbar styles
   * Used for search dropdown results
   */
  searchResults: `
    .search-results::-webkit-scrollbar {
      width: 8px;
    }
    .search-results::-webkit-scrollbar-track {
      background: ${colors.background.tertiary};
      border-radius: 3px;
    }
    .search-results::-webkit-scrollbar-thumb {
      background: ${colors.background.quaternary};
      border-radius: 3px;
    }
    .search-results::-webkit-scrollbar-thumb:hover {
      background: ${colors.background.elevated}
    }
  `,

  /**
   * Activities list scrollbar styles
   * Used for notifications/activities dropdown
   */
  activitiesList: `
    .activities-list::-webkit-scrollbar {
      width: 6px;
    }
    .activities-list::-webkit-scrollbar-track {
      background: ${colors.background.tertiary};
      border-radius: 3px;
    }
    .activities-list::-webkit-scrollbar-thumb {
      background: ${colors.background.quaternary};
      border-radius: 3px;
    }
    .activities-list::-webkit-scrollbar-thumb:hover {
      background: ${colors.background.elevated};
    }
  `,
};

/**
 * Utility function to inject scrollbar styles into the document head
 * @param styles - CSS string to inject
 * @param componentName - Name of the component for unique identification
 */
export const injectScrollbarStyles = (styles: string, componentName: string) => {
  if (typeof document !== 'undefined') {
    const styleElement = document.createElement('style');
    styleElement.textContent = styles;
    const dataAttribute = `data-scrollbar-${componentName}`;

    if (!document.head.querySelector(`style[${dataAttribute}]`)) {
      styleElement.setAttribute(dataAttribute, 'true');
      document.head.appendChild(styleElement);
    }
  }
};
